import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import moment from 'moment';
import Numeral from 'numeral';
import './styles.scss';

import defaultImage from './images/default-image.jpg';

const CarItem = ({
  delivery, isLink, image, name, to, perMounth
}) => {
  const linkRender = children => (
    <Link className="car-item" to={`/car/${to}`}>
      { children}
    </Link>
  );


  const parseUrl = () => {
    if (image) {
      const splitted = image.split('?');

      return splitted ? splitted[0] : defaultImage;
    }

    return defaultImage;
  };
  const blockRender = children => (
    <div className="car-item">
      {children}
    </div>
  );

  const renderDate = () => {
    const time = moment(delivery).format('h:mm A');
    const year = moment(delivery).format('DD/MM/YYYY');
    // const year = moment(delivery).format('MMMM YYYY');

    return `${time}  ${year}`;
  };

  const contentRender = () => (
    <React.Fragment>
      <div className="item-header">
        {/* <img className="item-image" src={parseUrl()} alt={name || ''} /> */}
        <div
          className="item-image"
          style={{ backgroundImage: `url(${parseUrl()}` }}
        />
        <div className="item-price">
          <p className="price-value">
        ${Numeral(perMounth).format('0.00')}
          </p>
          <p className="price-info">
        per month
          </p>
        </div>
      </div>
      <div className="item-bottom">
        <p className="item-title">
          {name}
        </p>
        { isLink ? <i className="icon-arrow-right" /> : null }
      </div>
      {
        delivery !== '' ? (
          <div className="item-delivery">
            <i className="material-icons">access_time</i>
            WILL BE DELIVERED {renderDate()}
          </div>
        ) : null
      }
    </React.Fragment>
  );

  return isLink ? linkRender(contentRender()) : blockRender(contentRender());
};

CarItem.defaultProps = {
  delivery: '',
  isLink: false,
  image: '',
  name: '',
  to: '',
  perMounth: 0
};

CarItem.propTypes = {
  delivery: PropTypes.string,
  isLink: PropTypes.bool,
  image: PropTypes.string,
  to: PropTypes.string,
  name: PropTypes.string,
  perMounth: PropTypes.number
};

export default CarItem;



// WEBPACK FOOTER //
// ./src/components/CarItem/index.js